import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Communication.css";
import TopHeader from "../../components/TopHeader.tsx";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import emailIcon from "../../assets/images/new-message.png";
import sentIcon from "../../assets/images/mail.png";
import jwtDecode from "jwt-decode";
import RichTextEditor from "../components/RichTextEditor.tsx";
import SentEmailsTable from "./SentEmailTable.tsx";

function Communication() {
  const apiAddress = process.env.REACT_APP_SECRET;
  const restaurant = localStorage.getItem("restaurant");

  var res = JSON.parse(restaurant as string);

  // State for switching between Create Email and Sent Emails
  // Default true for Create Email
  const [showCreateEmail, setShowCreateEmail] = useState(true);
  const [showSentEmails, setShowSentEmails] = useState(false);

  // Dropdown restaurant selection
  const [restaurants, setRestaurant] = React.useState([]);
  const [selectedchildRestaurant, setselectedchildRestaurant] = React.useState(
    JSON.parse(localStorage.getItem("restaurant")),
  );

  const handleRestaurantSelect = async (props) => {
    console.log(props);
    var obj = {
      id: props.id,
      name: props.name,
      ulsHLfS: props.isHomeCook,
      FMlYe6C: props.subscriptionPlanId,
    };
    localStorage.setItem("restaurant", JSON.stringify(obj));
    localStorage.setItem("restaurantChanged", "newRestaurantSeelected");

    // Broadcast the change to other tabs
    const broadcastChannel = new BroadcastChannel("storage_change_channel");
    broadcastChannel.postMessage("restaurantChanged");

    window.dispatchEvent(new Event("storage"));
    window.location.reload();
  };

  const loadDataForRestaurant = async () => {
    const restaurant = JSON.parse(localStorage.getItem("parentrestaurant"));
    axios
      .get(
        apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          "2e528a48-2121-48bd-97d4-b6ec8865bff2" +
          "/" +
          restaurant.id,
      )
      .then((response) => {
        console.log(response.data);
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
            subscriptionPlanId: dt.subscriptionPlanId,
          };
          list.push(obj);
        });
        setRestaurant(list);
      });
  };

  useEffect(() => {
    loadDataForRestaurant();
  }, [restaurant]);

  return (
    <>
      <TopHeader />
      <div className="communication_main-container">
        <div className="communication__side-bar">
          <div className="d-flex communication__side-bar-container">
            <div>
              <Box
                sx={{
                  maxWidth: "180px",
                  width: "13rem",
                  marginTop: "1rem",
                  marginBottom: "1rem",
                  marginLeft: ".5rem",
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {selectedchildRestaurant.name}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ marginLeft: "0px" }}
                    label="Restaurant Name"
                  >
                    {restaurants.map((dt, i) => {
                      return (
                        <MenuItem
                          key={i}
                          style={{ background: "none" }}
                          onClick={() => {
                            handleRestaurantSelect(dt);
                          }}
                          selected={selectedchildRestaurant.name == dt.name}
                        >
                          {dt.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>

          {/* Create Email Menu Item */}
          <div
            className={`communication_menuItem ${showCreateEmail ? "active" : ""}`}
            style={{
              width: "100%",
              height: "3rem",
              transition: "background-color 0.3s",
              borderRight: ".5px solid lightgray",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowCreateEmail(true);
              setShowSentEmails(false);
            }}
          >
            <div
              className="d-flex justify-content-start align-items-center ms-3"
              style={{ height: "100%", gap: "10px" }}
            >
              <img
                src={emailIcon}
                alt="create email"
                style={{ width: "1.2rem", height: "1.2rem" }}
              />
              <p
                style={{
                  color: "black",
                  fontWeight: "500",
                  marginBottom: "0px",
                  fontSize: "13px",
                }}
              >
                Create Email
              </p>
            </div>
          </div>

          {/* Sent Emails Menu Item */}
          <div
            className={`communication_menuItem ${showSentEmails ? "active" : ""}`}
            style={{
              width: "100%",
              height: "3rem",
              transition: "background-color 0.3s",
              borderRight: ".5px solid lightgray",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowCreateEmail(false);
              setShowSentEmails(true);
            }}
          >
            <div
              className="d-flex justify-content-start align-items-center ms-3"
              style={{ height: "100%", gap: "10px" }}
            >
              <img
                src={sentIcon}
                alt="sent emails"
                style={{ width: "1.2rem", height: "1.2rem" }}
              />
              <p
                style={{
                  color: "black",
                  fontWeight: "500",
                  marginBottom: "0px",
                  fontSize: "13px",
                }}
              >
                Sent Emails
              </p>
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        {showCreateEmail ? (
          <div className="communication__create-email-page-container">
            <RichTextEditor restaurantId={res.id} restaurantName={res.name} />
          </div>
        ) : (
          <div className="communication__sent-emails-page-container">
            <SentEmailsTable></SentEmailsTable>
          </div>
        )}
      </div>
    </>
  );
}

export default Communication;
